import { filter, Observable } from "rxjs"

const isNotNull = <T>(value: T | undefined | null): value is T =>
  value !== null && value !== undefined

export const filterNotNull =
  <T>() =>
  (obs: Observable<T | null | undefined>) =>
    obs.pipe(filter(isNotNull))
